import React, { useEffect, createContext, useContext } from 'react';
type Theme = 'light';
type ThemeContextType = {
  theme: Theme;
  toggleTheme: () => void;
};
const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
export function ThemeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'light');
  }, []);
  return <ThemeContext.Provider value={{
    theme: 'light',
    toggleTheme: () => {}
  }} data-id="element-1200">
      {children}
    </ThemeContext.Provider>;
}
export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
}